<template>
  <v-app>
    <v-app-bar app color="#21343b" elevation="0" height="80" v-if="!isLoading">
      <v-container>
        <v-row justify="center" align="center">
          <v-col>
            <!-- <router-link to="/" class="black--text"> -->
            <h1 @click="goHome()" class="logo float-left">Tape</h1>
            <!-- </router-link> -->
          </v-col>
          <v-spacer />
          <!-- 테스트를 위한 코드 시작 -->
          <!-- <v-col class="col-auto ml-0 mr-0 pl-0 pr-0" align="right">
            <v-select no-gutters dark v-model="$i18n.locale" :items="langs" dense outlined>
              <template slot="selection" slot-scope="data">{{ $t(`language.${data.item}`) }}</template>
              <template slot="item" slot-scope="data">{{ $t(`language.${data.item}`) }}</template>
            </v-select>
          </v-col> -->

          <!-- SignIn / SignUp 하나로 사용해서 제거 -->
          <!-- <v-col class="col-auto" align="right">
            <v-btn
              text
              color="white"
              @click="$router.push({ name: 'SignIn' })"
              v-if="!$store.getters.currentUser && !isContain('SignIn') && (!userInfo || userInfo.userStatus !== 'G')"
            >
              {{ $t('signIn') }}
            </v-btn>
            <v-btn
              text
              color="white"
              @click="$router.push({ name: 'SignUp' })"
              v-if="!$store.getters.currentUser && !isContain('SignUp') && (!userInfo || userInfo.userStatus !== 'G')"
            >
              {{ $t('signUp') }}
            </v-btn>
            <v-btn text dark @click="setSignOut" v-if="$store.getters.currentUser && !$route.name.includes('Sign')">
              {{ $t('signOut') }}
            </v-btn>
          </v-col> -->
          <!-- 테스트를 위한 코드 끝 -->
        </v-row>
      </v-container>
    </v-app-bar>
    <v-main>
      <v-container fill-height>
        <v-container fluid>
          <slot name="logo" />
          <slot name="title" />
          <slot name="desc" />
          <slot name="content" />
        </v-container>
      </v-container>
    </v-main>
    <loading-dialog />
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LoadingDialog from '@/views/modal/LoadingDialog'

export default {
  name: 'OnboardingLayout',
  data: () => ({
    langs: ['en', 'ko'],
  }),
  components: {
    LoadingDialog,
  },
  computed: {
    ...mapState({
      userInfo: (state) => {
        return state.auth.userInfo
      },
      isLoading: (state) => {
        return state.loading.isLoading
      },
    }),
    isLoading() {
      if (this.userInfo && this.userInfo.userStatus !== 'G') {
        return true
      } else return this.$store.getters.chk_isLoading
    },
  },
  methods: {
    ...mapActions(['setSignOut']),
    isContain(val) {
      return this.$route.name.includes(val)
    },
    async goHome() {
      await this.$store.dispatch('setSignInRedirectUrl', null)
      location.href = 'https://www.tape.ooo'
    },
  },
}
</script>

<style scoped>
.v-select >>> .v-input__slot {
  margin-bottom: 0 !important;
}
.v-select >>> .v-text-field__details {
  display: none !important;
}
h1.logo {
  position: relative;
  width: 108px;
  height: 30px;
  padding-left: 62px;
  /* background: url('~@/assets/img/tape-logo-typo.png') no-repeat right;
  background-size: 43px 17px;
  font-size: 0;
  text-indent: -9999px; */
  font-size: 18px;
  font-weight: 900;
  line-height: 30px;
  overflow: hidden;
  cursor: pointer;
  color: white;
}

h1.logo:before {
  content: '';
  position: absolute;
  left: 0;
  width: 48px;
  height: 30px;
  background: url('~@/assets/img/tape-logo.png') no-repeat center;
  background-size: cover;
}

.container >>> h2 {
  font-size: 36px;
  font-weight: 700;
  cursor: default;
}

.container >>> h2.big {
  font-size: 48px;
}

.container >>> h4 {
  font-size: 18px;
  font-weight: 500;
  cursor: default;
}

.container >>> h4.big {
  font-size: 32px;
}

.container >>> p.desc {
  font-size: 24px;
  font-weight: 500;
  color: #96a7af;
  cursor: default;
}

.white {
  color: white;
}

.container >>> form {
  max-width: 400px;
  margin: 0 auto;
}

.container >>> form.sign {
  max-width: 314px;
}

.container >>> .v-btn.v-btn--active.no-active:not(:hover)::before {
  opacity: 0 !important;
}

.container >>> .v-btn * {
  font-size: 16px;
  letter-spacing: 0;
  text-transform: none;
}

.container >>> .google span.icon {
  width: 22px;
  height: 22px;
  background: url('~@/assets/img/google-icon.png') no-repeat center;
  background-size: cover;
}

.container >>> form .col:not(.logo) label,
.container >>> form input {
  font-size: 14px;
  line-height: 14px;
}

.container >>> form .col:not(.logo) label {
  display: block;
  margin-bottom: 7px;
  font-weight: 500;
}

.container >>> .col.company,
.container >>> .col.logo {
  font-size: 18px;
  line-height: 22px;
  color: #666;
}

.container >>> form label .optional {
  color: #999;
}

.container >>> .v-alert {
  font-size: 14px;
}
</style>
